import {useDebugValue} from 'react';

import {undef} from '../../../utils';

import {useOptions} from './';

const defaultOptions = {
    delayProcessing: 'true',
    searchSubmitEventActionLocation: 'search-widget',
    searchQuerySubmittedEventActionLocation: undef
};

const fixedOptions = {
    searchSubmitEventName: 'search.submit',
    datedSearchSubmitEventName: 'dated.search.submit',
    searchQuerySubmittedEventName: 'search_query.submitted'
};

function useEdapOptions(props) {
    const {
        edapOptions: propsOptions
    } = props;

    const {
        options
    } = useOptions(defaultOptions, propsOptions, fixedOptions);

    const result = {
        options
    };

    useDebugValue(result);

    return result;
}

export {useEdapOptions};
